import CircularProgress from '@mui/material/CircularProgress';
import './template.css' 


export const CenterContainer = ({ children }) => <div className='center-container'>{children}</div>

export const LoadingIndicator = ({ loadingMsg }) => {
    return (<div className='loading-indicator-wrapper'>
        {loadingMsg && <h5 className='loading-indicator-message'>{loadingMsg}</h5>}
        <CircularProgress />
    </div>)
}
